var CoordinateNote = require('./base'),
    HighlightShapeModel = require('../../../../../../canvas/models/coordinate/highlight'),
    HighlightNoteView = require('../../../../../views/note/highlight/view');



module.exports = CoordinateNote.extend({

    SUPPORTS_FIND_AND_REDACT: true,

    init: 'H',
    desc: 'Highlight',
    createHotKey: 'h',
    actionTitle: 'Highlight',
    iconClass: 'icon-pencil-6',
    defaultShapeColor: '#FFF600',
    ShapeModel: HighlightShapeModel,
    ViewConstructor: HighlightNoteView

});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/notes/models/page/noteTypes/drawable/coordinate/highlight.js
 ** module id = 287
 ** module chunks = 0
 **/